// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/spin-aerodynamics.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/spin-aerodynamics/spin-aerodynamics.js';

mount([g0]);
